import { onBeforeUnmount } from "vue";

const TRANSITION_DURATION = 200;

export const defaultBackdropStyle = {
  position: "fixed",
  top: "0",
  left: "0",
  width: "100vw",
  height: "100vh",
  backgroundColor: "#000",
  opacity: "0.3",
  zIndex: "9999",
  pointerEvents: "auto",
  transition: "opacity 200ms ease",
  cursor: "pointer",
};

export const useBackdrop = () => {
  const backdropId = "vue-backdrop-overlay";
  const body = document.body;

  const showBackdrop = ({ styles = {} } = {}) => {
    if (document.getElementById(backdropId)) {
      return;
    }

    const backdrop = document.createElement("div");
    backdrop.id = backdropId;

    // Apply all styles except opacity first because it will be animated
    const style = { ...defaultBackdropStyle, ...styles };
    Object.entries(style).forEach(([key, value]) => {
      if (key !== "opacity") {
        backdrop.style[key] = value;
      }
    });

    backdrop.style.opacity = "0";

    body.appendChild(backdrop);

    requestAnimationFrame(() => {
      backdrop.style.opacity = style.opacity || "0.3";
    });

    backdrop.addEventListener("click", () => {
      backdrop.style.opacity = "0";

      setTimeout(() => {
        if (document.body.contains(backdrop)) {
          body.removeChild(backdrop);
        }
      }, TRANSITION_DURATION);
    });
  };

  const hideBackdrop = () => {
    const backdrop = document.getElementById(backdropId);
    if (backdrop) {
      backdrop.style.opacity = "0";

      setTimeout(() => {
        if (document.body.contains(backdrop)) {
          body.removeChild(backdrop);
        }
      }, 200);
    }
  };

  onBeforeUnmount(() => hideBackdrop());

  return {
    showBackdrop,
    hideBackdrop,
  };
};
